/*
 * @Author: ezhizao 庄德政
 * @LastEditors: ezhizao 庄德政
 * @Description: 
 */
const RootPath = window.g.baseUrl
const apis = {
  /* 企业管理 */
  /*子用户管理 */
  GetList: RootPath + 'plugin/websys/core/map/GetList',
  getcard:RootPath + 'plugin/websys/core/map/GetCard',
  Save: RootPath + 'plugin/websys/core/map/Save',
}

export default apis